"use strict";

// Decide whether to render a cached form instead of fetching from the network.
// Rules:
// - requestHook=true always fetches (can mutate form data server-side).
// - authLevel 0/undefined: allow cache.
// - authLevel 1: allow cache when offline; require authentication when online.
export function shouldUseCachedForm({
  authLevel = 0,
  requestHook = false,
  isOnline = true,
  isAuthenticated = false
}) {
  if (requestHook) return false;

  const requiresAuth = authLevel === 1;
  if (!requiresAuth) return true;
  if (!isOnline) return true;
  return !!isAuthenticated;
}


